'use client'
import { createContext, useState } from 'react'
import type { FC, ReactNode, Dispatch, SetStateAction } from 'react'

type TypeImgData = {
  src: string
  size: {
		top: number
		left: number
    width: number
    height: number
  }
}
type TypeContextData = {
  startTransition: boolean,
  setStartTransition: Dispatch<SetStateAction<boolean>>
  imgData?: TypeImgData
  setImgData?: Dispatch<SetStateAction<TypeImgData>>
}

const initialContextData: TypeContextData = {
  startTransition: true,
  setStartTransition: () => { },
}

interface Props {
  children: ReactNode
}

export const TransitionToSuiteContext = createContext<TypeContextData>(initialContextData)
export const TransitionToSuiteProvider: FC<Props> = ({ children }) => {
  const [startTransition, setStartTransition] = useState<boolean>(false)
  const [imgData, setImgData] = useState<TypeImgData>(undefined)

  return <TransitionToSuiteContext.Provider value={{
    startTransition, setStartTransition,
    imgData, setImgData
  }}>{children}</TransitionToSuiteContext.Provider>
}
